import request from "../utils/request";

export async function checkForPin(payload) {
  return request.post("SelfService/CheckForPin", payload);
}
export async function changePassword(payload){
  return request.post("cart/ChangePassword",payload);
}
export async function reloadProductCache(){
  return request.get("Sale/ReloadProductCache");
}
export async function completePayment(cart) {

  return new Promise((resolve, reject) => {
    request.post("cart/place-order",cart).then(response => {
      if (response.status != 200) {
        reject(new Error(response.data.message));
      }
      resolve(response.data);
    }).catch(e => {
      reject(e);
    });
  });
}

export async function ReduceFromWallet(qrCode,amount) {

  let payload = {
    qrCode : qrCode,
    amount : amount
  }
  return await request.post("cart/pay",payload);
}

export async function fetchLastBillId() {
  return new Promise((resolve, reject) => {
    request.get("cart/GetLastBillId").then(response => {
      if (response.status != 200) {
        reject(new Error(response.data.message));
      }
      resolve(response.data);
    }).catch(e => {
      reject(e);
    });
  });
}
export async function mobileOrder(){
  return (await request.get("Sale/mobile-order")).data;
}
export async function mobileOrderChangeStatus(payload){
  return (await request.put("Sale/mobile-order",payload)).data;
}
export async function qrCodeRead(qrCode){
  return (await request.get("Sale/qr-code?qrCode="+qrCode)).data;
}
export async function addDiscountLog(payload) {
  return request.post("cart/add-discount-log", payload);
}
